import React, { useMemo } from 'react';
import Tooltip from 'react-tooltip-lite';

import styles from './Badges.module.css';

import { Avatar } from '@/shared/components/atoms/Avatar';
import { Typography } from '@/shared/components/atoms/Typography';
import { clsxm } from '@/shared/lib';

import { IBadgesProps } from './IBadges';

export default function Badges<T>({
  getLabel,
  getImage,
  badgesList,
  className,
  wrapperClassName,
  showedBadgesWrapperClassName,
  variant = 'withBg',
  tooltipProps,
  show = 3,
  labelTypographyVariant = 'minText',
  customLabel,
}: IBadgesProps<T>) {
  const badgeClasses = clsxm(
    styles.shared,
    styles[`variant-${variant}`],
    'bg-blue-100',
    className
  );
  const countBadgeClasses = clsxm(
    styles.shared,
    styles[`variant-${variant}-countBadge`],
    'bg-blue-100',
    className
  );
  // const tooltipContentclasses = clsxm(styles.wrapperTooltipContent);
  // const isLabtopScreen = useMatchMedia(`(min-width: ${screens.laptop})`);
  // const isMobileScreen = useMatchMedia(`(min-width: ${screens.mobile})`);

  const wrapperClasses = clsxm(styles.wrapper, wrapperClassName);
  const slicedWrapperClasses = clsxm(
    'flex items-center gap-6 overflow-x-auto scrollbar-thin',
    showedBadgesWrapperClassName
  );

  // filter nulls values of labels
  const badgesListFilterNullBadges = useMemo(
    () => badgesList.filter((badge) => getLabel(badge)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [badgesList]
  );
  const slicedBadges = badgesListFilterNullBadges?.slice(0, show);
  const restBadges = badgesListFilterNullBadges?.slice(show);

  return (
    <div className={wrapperClasses}>
      {/* ******************* main badges ********************** */}
      <div className={slicedWrapperClasses}>
        {slicedBadges?.map(
          (badge, i) =>
            getLabel(badge) && (
              <span key={i} className={badgeClasses}>
                {customLabel ? (
                  customLabel(getLabel(badge))
                ) : (
                  <Typography
                    key={i}
                    variant={labelTypographyVariant}
                    weight='bold'
                    className='flex items-center gap-8'
                  >
                    {getImage
                      ? getImage(badge) && (
                          <Avatar size='xxs' src={getImage(badge)} />
                        )
                      : null}
                    {getLabel(badge)}
                  </Typography>
                )}
              </span>
            )
        )}
      </div>
      {restBadges?.length !== 0 && (
        // ***************** tooltip over rest badges **************
        <Tooltip
          // className={tooltipContentclasses}
          arrow={false}
          tagName='div'
          direction='left-start'
          mouseOutDelay={500}
          content={
            <div className='max-h-343 flex-col overflow-y-auto rounded-lg   bg-white  p-16 text-start shadow-100'>
              {restBadges?.map((badge, i) => (
                <div key={i} className=' inline-flex gap-8 '>
                  {getImage
                    ? getImage(badge) && (
                        <Avatar size='xs' src={getImage(badge)} />
                      )
                    : null}
                  {getLabel(badge) && (
                    <Typography className='pb-16 last:pb-0' variant='body2'>
                      {getLabel(badge)}
                    </Typography>
                  )}
                </div>
              ))}
            </div>
          }
          {...tooltipProps}
        >
          {/* ******************* badge count ********************** */}

          <div className={countBadgeClasses}>
            <Typography
              variant='minText'
              weight='bold'
              className='whitespace-nowrap'
            >
              {variant === 'text' && '...'} + {restBadges?.length}
            </Typography>
          </div>
        </Tooltip>
      )}
    </div>
  );
}
